export const calculateAverageOrder = (
  lifetimeValueOrders: number | undefined | null,
  totalOrders: number | undefined | null
): string => {
  if (lifetimeValueOrders && totalOrders && totalOrders >= 1)
    return parseFloat(
      (lifetimeValueOrders / totalOrders).toFixed(6)
    ).toString();
  return "";
};
